import { cn } from "@preview-kit/ui/lib/utils"
import React from "react"

interface CommandItemProps {
	icon: React.ComponentType<{ className?: string }>
	name: string
	type: string
	color: string
	canPin?: boolean
	shortcut?: string
	selected?: boolean

	onClick?: () => void
}

export const CommandItemComponent = React.forwardRef<
	HTMLButtonElement,
	CommandItemProps
>(({ icon: Icon, name, color, onClick, selected = false, shortcut }, ref) => {
	// Create gradient based on the base color
	const createGradient = (baseColor: string) => {
		const hex = baseColor.replace("#", "")
		const r = Number.parseInt(hex.substr(0, 2), 16)
		const g = Number.parseInt(hex.substr(2, 2), 16)
		const b = Number.parseInt(hex.substr(4, 2), 16)
		const lighterR = Math.min(255, Math.floor(r * 1.3))
		const lighterG = Math.min(255, Math.floor(g * 1.3))
		const lighterB = Math.min(255, Math.floor(b * 1.3))
		const lighterColor = `rgb(${lighterR}, ${lighterG}, ${lighterB})`
		return `linear-gradient(135deg, ${baseColor} 0%, ${lighterColor} 100%)`
	}

	return (
		<button
			ref={ref}
			className={cn(
				selected ? "!bg-gray-100" : "",
				"w-full flex items-center gap-3 px-2 py-2 rounded-md command-hover transition-colors text-left group text-[#111]",
			)}
			onClick={onClick}
		>
			<div
				className="flex-shrink-0 w-8 h-8 rounded-md flex items-center justify-center shadow-sm"
				style={{ background: createGradient(color) }}
			>
				<Icon className="w-4 h-4 text-white drop-shadow-sm" />
			</div>
			<div className="flex-1 min-w-0">
				<div className="text-sm">{name}</div>
			</div>
			{shortcut && (
				<div>
					<kbd className="px-1 py-0.5 rounded text-[10px] kbd !bg-neutral-50">
						{shortcut}
					</kbd>
				</div>
			)}
		</button>
	)
})
